import { useState } from 'react';
import { useAuth } from 'context/AuthContext';
import DeleteIcon from 'icons/DeleteIcon';
import CustomButton from 'components/buttons/CustomButton/CustomButton';
import DeleteRegistryPatientsDialog from '../DeleteRegistryPatientsDialog/DeleteRegistryPatientsDialog';

interface Props {
  ids: number[];
  refetch?: () => void;
}

export default function DeleteRegistryPatientsButton({ ids, refetch }: Props) {
  const { user } = useAuth();
  const [open, setOpen] = useState(false);

  return (
    <>
      <CustomButton
        text='Delete'
        variant='outlined'
        intent='error'
        color='error'
        onClick={() => setOpen(true)}
        height={40}
        startIcon={<DeleteIcon size={14} />}
      />

      <DeleteRegistryPatientsDialog
        open={open}
        setOpen={setOpen}
        procedureIds={ids}
        refetch={refetch}
      />
    </>
  );
}
